// src/components/richtext/EditorErrorBoundary.jsx
import React from 'react'

export default class EditorErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('RichTextEditor crashed:', error, info)
  }

  reset = () => this.setState({ error: null })

  render() {
    if (this.state.error) {
      return (
        <div className="rte-tt-container rte-tt-error-state" role="alert">
          <div className="rte-tt-error-message">
            <strong>The editor failed to load.</strong>
            <p>This usually means the saved document is corrupted or used an unsupported feature.</p>
            <button type="button" className="rte-btn" onClick={this.reset}>Try again</button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
